import { renderArrowMarker } from 'app/image/rasterize/markers/arrow';
import { renderEllipseMarker } from 'app/image/rasterize/markers/ellipse';
import { renderHighlightMarker } from 'app/image/rasterize/markers/highlight';
import { renderImageMarker } from 'app/image/rasterize/markers/image';
import { renderLineMarker } from 'app/image/rasterize/markers/line';
import { renderPathMarker } from 'app/image/rasterize/markers/path';
import { renderPolylineMarker } from 'app/image/rasterize/markers/polyline';
import { renderRectMarker } from 'app/image/rasterize/markers/rect';
const MarkerRenderers = {
    Arrow: renderArrowMarker,
    Ellipse: renderEllipseMarker,
    Line: renderLineMarker,
    Polyline: renderPolylineMarker,
    Path: renderPathMarker,
    Highlight: renderHighlightMarker,
    Rect: renderRectMarker,
    Image: renderImageMarker,
};
export default MarkerRenderers;
